import "core-js/features/promise";
import { ShowReadingEntryLink } from "../../../Areas/eServices/Scripts/Default/ShowReadingEntryLink";
import { ILoaderFactory } from "../../inpulse/Loaders/ILoader";
import { DefaultLoaderFactory } from "../../inpulse/Loaders/DefaultLoaderFactory";
import { DefaultValidationNotificator, IValidationNotificator } from "../../inpulse/Notificators/IValidationNotificator";
import * as $ from "jquery";
import { InternationalPhoneInput, InternationalPhoneInputInitializer, InternationalPhoneInputSettings, ValidationMessages } from "../../country/InternationalPhoneInput";
import { Countries } from "../../country/country";
import { IValidationFailureHandler, DefaultValidationFailureHandler, DefaultValidationFailureHandlerSettings, FindMode, FindResultMode } from "../../inpulse/ValidationFailureHandlers/IValidationFailureHandler";
import { INotificator } from "../../inpulse/Notificators/INotificator";
import { BootstrapNotificator } from "../../inpulse/Notificators/BootstrapNotificator";
import { DefaultContractService } from "../../vue-components/mycontracts/ContractService";

//declare var readingEntryApiUrl: string;
declare var window: Window;
declare var userAccesses: UserAccesses;
declare var childTheme: string;
declare var apiUrl: string;

declare interface UserAccesses {
    readAccessContacts: boolean;
    readAccessReadingEntry: boolean;
    readAccessContracts: boolean;
}

declare interface Window {
    root: any;
    _lf: ILoaderFactory;
    _notificator: IValidationNotificator;
    _nf: INotificator;
    _eh: IValidationFailureHandler;
    InternationalPhoneInputValidationMessages: ValidationMessages;
    location: Location;
    ReadingEntryPermissionModule: ShowReadingEntryLink;
    ContractService: DefaultContractService;
}

declare interface Location {
    href: string;
    pathname: string;
    search: string;
    origin: string;
}

declare interface root {
    countries: Countries;
    InternationalPhoneInputSettings: InternationalPhoneInputSettings;
    InternationalPhoneInputInitializer: InternationalPhoneInputInitializer;
}

window._lf = new DefaultLoaderFactory();
window._notificator = new DefaultValidationNotificator();
window._nf = new BootstrapNotificator();
window._eh = new DefaultValidationFailureHandler(window._notificator, window._nf, new DefaultValidationFailureHandlerSettings(FindMode.FirstIDThenName, FindResultMode.Multiple));

window.root = { countries: Countries, InternationalPhoneInputSettings: InternationalPhoneInputSettings, InternationalPhoneInputInitializer: InternationalPhoneInputInitializer };
window.root.countries = new Countries();
if (window.InternationalPhoneInputValidationMessages === window['undefined'] || window.InternationalPhoneInputValidationMessages === null) {
    window.InternationalPhoneInputValidationMessages = new ValidationMessages();
}
window.root.InternationalPhoneInputSettings = new InternationalPhoneInputSettings(true, window.InternationalPhoneInputValidationMessages);
window.root.InternationalPhoneInputInitializer = new InternationalPhoneInputInitializer(document, window.root.InternationalPhoneInputSettings)
window.ContractService = new DefaultContractService(apiUrl, document.getElementById("follow-up-contract-count"));

$(function () {
    $("#navbarNavDropdown > ul > li > a[href='" + window.location.pathname + window.location.search + "']").parent().addClass("active");

    if (userAccesses.readAccessContracts === true) { // todo restrict module to child themes with follow-up offers in use
        var followUpOffers = window.ContractService.GetFollowUpOffers();
        window.ContractService.ShowFollowUpProcessesCount(followUpOffers);
    }
});